import { render, staticRenderFns } from "./FeatureColumns.vue?vue&type=template&id=e05eca38&scoped=true"
import script from "./FeatureColumns.vue?vue&type=script&lang=js"
export * from "./FeatureColumns.vue?vue&type=script&lang=js"
import style0 from "./FeatureColumns.vue?vue&type=style&index=0&id=e05eca38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05eca38",
  null
  
)

export default component.exports